import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  SettingModel,
  PopularProducts,
  SelectedCountry,
} from "./InitialStatePropsModel";
import { OrderItem } from "../../Services/OrderService";
import { OrderData } from "../../Helpers/Interfaces/OrderType";

const initialState: SettingModel = {
  banners: [],
  error: "",
  isLoading: false,
  categoryList: [],
  countryDialingList: [],
  popularProducts: [],
  trendingProducts: [],
  address: [],
  selectedCountry: {
    label: "Germany",
    value: "DE",
    flag: "https://flagcdn.com/de.svg",
  },
  countryList: [
    {
      name: { common: "Germany" },
      flags: {
        png: "https://flagcdn.com/w320/de.png",
        svg: "https://flagcdn.com/de.svg",
      },
    },
  ],
  orderData: {},
  adyenSession: {},
  refillCategoryList: [],
  orderNumberForRedirect: "",
  paymentHandled: false,
};

const SettingSlice = createSlice({
  name: "SettingSlice",
  initialState,
  reducers: {
    setBannerData(state: any, action: any) {
      state.banners = action.payload;
    },
    setCategory(state: any, action: any) {
      state.categoryList = action.payload;
    },
    setCounty(
      state: any,
      action: PayloadAction<{ countryList?: any; countryDialingList?: any }>,
    ) {
      state.countryList = action.payload.countryList;
    },
    setCountryDialingList(
      state: any,
      action: PayloadAction<{ countryDialingList?: any }>,
    ) {
      state.countryDialingList = action.payload.countryDialingList;
    },
    setPopularProduct(state: any, action: PayloadAction<PopularProducts[]>) {
      // Extract only required fields
      const filteredProducts: PopularProducts[] = action.payload.map(
        (item) => ({
          productName: item.productName,
          productImage: item.productImage,
          _id: item._id,
        }),
      );

      // Store the required products in state
      state.popularProducts = filteredProducts.slice(2, 6); // Products 3-6
      state.trendingProducts = filteredProducts.slice(0, 2); // First 2 products
    },

    setAddAddress(state: any, action: PayloadAction<any>) {
      state.addresses = action.payload;
    },

    setSelectedCountries(state: any, action: PayloadAction<SelectedCountry>) {
      state.selectedCountry = action.payload;
    },
    setOrderItems(state: any, action: PayloadAction<any>) {
      state.orderData = action.payload;
    },
    setAdyenSessionData(state: any, action: PayloadAction<any>) {
      state.adyenSession = action.payload;
      state.paymentHandled = false;
    },
    makePaymentHandled(state: any) {
      state.paymentHandled = true;
    },
    clearAdyenSessionData(state: any) {
      state.adyenSession = {};
    },
    setRefillCategory(state: any, action: any) {
      state.refillCategoryList = action.payload;
    },
    setOrderNumber(state: any, action: any) {
      state.orderNumberForRedirect = action.payload;
    },
  },
});
export const selectCountryList = (state: any) =>
  state.SettingSlice?.countryList || [];
export const {
  setBannerData,
  setCategory,
  setCounty,
  setPopularProduct,
  setCountryDialingList,
  setAddAddress,
  setSelectedCountries,
  setOrderItems,
  setAdyenSessionData,
  makePaymentHandled,
  setRefillCategory,
  clearAdyenSessionData,
  setOrderNumber,
} = SettingSlice.actions;
export default SettingSlice;
